// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import axios from './http'
import App from './App'
import router from './routes';//引用路由
import echarts from 'echarts';

import verify from "vue-verify-plugin";
import {store} from "./store/store";
import 'lib-flexible';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);


import qs from 'qs'

import Blob from "./excel/blob"
import Export2Excel from "./excel/export2excel"



// axios.defaults.headers.common['token']="";
// axios.defaults.headers.post['Content-type']="application/json";

//设置axios为form-data
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.transformRequest = [function (data) {
//   let ret = '';
//   for (let it in data) {
//     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//   }
//   return ret
// }];

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.use(verify, {
  blur: true // 失焦是否触发
});

// const router = new VueRouter({
//   routes,
//   mode:'history'
// });
//
// //全局守卫
// router.beforeEach((to,from,next)=>{
//   const IsLogin = localStorage.eleToken ? true : false
//   if (to.path == '/login'){
//     next()
//   }else {
//     IsLogin ? next() : next('/login')
//   }
// });

router.beforeEach((to, from, next) => {
  console.log(store)
let isLogin = localStorage.getItem('isLogin');
 let token = localStorage.getItem('token');
 console.log(token)
//  let id = localStorage.getItem('id');
 if (to.meta.requireAuth) {  // 判断是否有权限
  if (!token) {  // store和localStorage中登录状态都为false并且跳转到 不是登录的页面时 都强行跳转到登录页面  
   next({
    path: '/',
   });
  } 
  // else if (token!=="" && to.path !== '/') {  // 已经在登录页面进入首页的时候
  //   localStorage.setItem('token', token);
  //  next();
  else if (token!=="" && to.path !== '/') {  // 登录进入后刷新页面时
   store.commit('setToken', token);
   store.commit('setIslogin', isLogin);
  //  store.commit('SET_ID', id);
   next();
  } else {
   next();
  }
 }
 else {
  next();
 }
});


new Vue({
  store:store,
  router,
  el: '#app',
  render:h=>h(App)
  // components: { App },
  // template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js